<script>
import genericService from '../../services/genericService';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import InputText from 'primevue/inputtext';
import Timeline from 'primevue/timeline';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

export default{
  components: {
    InputText,
    ResponsiveButton,
    Timeline,
    DataTable,
    Column,
    Checkbox
},
  data(){
    return {
      code: null,
      checklist: [],
      timeline: []
    }
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'movementInstructionChecklist.page_title');
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      utils(){
        return Utils;
      }
  },
  methods: {
    goBack(){
        this.$router.back();
    },
    async getChecklist(){
      if (this.code) {
        await genericService.get('checklist?allocationCode='+this.code).then(({success, data, message}) => {
          if(success) {
            this.checklist = data.items;
            this.timeline = data.items.filter((item) => item.showInTimeline);
          } else {
            this.checklist = [];
            this.timeline = [];
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }
    },
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12">
          <label for="code">{{$t('movementInstructions.insertCode')}}</label>
          <InputText id="code" type="text" v-model="code" class="mx-2"/>
          <ResponsiveButton :label="$t('movementInstructions.btn.load')" icon="pi pi-upload" class="p-button-info mr-2" @click="getChecklist"/>
        </div>
        <div class="col-12" v-if="timeline.length">
          <Timeline :value="timeline" layout="horizontal" align="alternate">
            <template #opposite>
              &nbsp;
            </template>
            <template #content="slotProps">
              <div v-tooltip="slotProps.item.description" class="custom-checklist">
                {{slotProps.item.description}}
              </div>
            </template>
            <template #marker="slotProps">
              <span class="custom-marker" :class="{'completed': slotProps.item.isCompleted}">
              </span>
            </template>
          </Timeline>
        </div>
        <div class="col-12" v-if="checklist.length">
          <DataTable :value="checklist" :reorderableColumns="true">
            <Column field="description" :header="$t('movementInstructions.eventDescription')"></Column>
            <Column field="completionDate" :header="$t('movementInstructions.completionDate')">
              <template #body="{data}">
                {{utils.formatDateTime(data.completionDate)}}
              </template>
            </Column>
            <Column field="isCompleted" :header="$t('movementInstructions.completed')">
              <template #body="{data}">
                <Checkbox v-model="data.isCompleted" :binary="true" :disabled="true"/>
              </template>
            </Column>
        </DataTable>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>

.custom-checklist {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
}

.custom-marker {
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 1;
  border: 2px solid yellow;
  background-color: orange;
}

.custom-marker.completed {
  border: 2px solid lightgreen;
  background-color: green;
}

</style>